// src/_nav.js

export default [
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    component: 'CNavTitle',
    name: 'Business',
  },
  {
    component: 'CNavItem',
    name: 'Calendar',
    to: '/business/calender',
    icon: 'cil-calendar',
  },
  {
    component: 'CNavItem',
    name: 'KPIs',
    to: '/business/kpi',
    icon: 'cil-chart-line',
    roles: ['owner'],
  },
  {
    component: 'CNavItem',
    name: 'Schedule Settings',
    to: '/business/schedule-settings',
    icon: 'cil-clock',
    roles: ['owner', 'manager'],
  },
  {
    component: 'CNavItem',
    name: 'Employees',
    to: '/business/employees',
    icon: 'cil-people',
    roles: ['owner'],
  },
  {
    component: 'CNavItem',
    name: 'Services',
    to: '/business/services',
    icon: 'cil-briefcase',
    roles: ['owner'],
  },
  {
    component: 'CNavItem',
    name: 'Locations',
    to: '/business/locations',
    icon: 'cil-location-pin',
    roles: ['owner'],
  },
  {
    component: 'CNavTitle',
    name: 'Account',
  },
  {
    component: 'CNavItem',
    name: 'Settings',
    to: '/account/settings',
    icon: 'cil-settings',
  },
  {
    component: 'CNavItem',
    name: 'Billing',
    to: '/account/billing',
    icon: 'cil-credit-card',
    roles: ['owner'],
  },
  {
    component: 'CNavItem',
    name: 'Help',
    to: '/help',
    icon: 'cil-info',
  },
  {
    component: 'CNavItem',
    name: 'Setup',
    to: '/setup',
    icon: 'cil-equalizer',
    setup: true,
  },
]
